import { post, postJson,get,put,deleteApi } from '../axios'

const RESOURCE_BASE_PATH = '/jdBindshopRecord';


// 店铺绑定列表
export const findShopBind = p => get(`${RESOURCE_BASE_PATH}/findShopBind`, p);


// 拒绝申请
export const applyId = p => deleteApi(`${RESOURCE_BASE_PATH}/apply/`+p.id);


//申请绑定店铺
export const applyApplicationBinding = p => post(`${RESOURCE_BASE_PATH}/apply`,p);


// 取消绑定
export const cancelBind = p => deleteApi(`${RESOURCE_BASE_PATH}/bind/`+p.id);


//同意
export const accessBind = p => post(`${RESOURCE_BASE_PATH}/bind/`+p.id);


//多店铺绑定验证码
export const checkCode = p => get(`${RESOURCE_BASE_PATH}/checkCode`,p);





